
import React, { Ref } from 'react'
import { BsFillPersonCheckFill, BsFillPersonPlusFill } from "react-icons/bs";
import styled from 'styled-components';
import tw from 'twin.macro';
import styles from '../common/styles';
import { DPButton } from '../common/types';

interface Props extends DPButton {
	isSubscribed: boolean
}
 
const SubscribeButton = (props: Props) => {
	return (
    <Button
      {...props}
			ref={props.ref as Ref<HTMLButtonElement>}
      isSubscribed={props.isSubscribed}
    >
      {props.isSubscribed ? (
        <>
          <Text>Subscribed</Text>
          <BsFillPersonCheckFill />
        </>
      ) : (
        <>
          <Text>Subscribe</Text>
          <BsFillPersonPlusFill />
        </>
      )}
    </Button>
  );
}

const Button = styled.button(({ isSubscribed }: { isSubscribed: boolean }) => [
  tw`flex items-center px-1.5 py-0.5 text-[0.4rem] cursor-pointer gap-x-0.5 text-pink-400`,
  styles.border,
  isSubscribed && tw`bg-pink-400 text-white`,
]);

const Text = styled.p(() => [tw``]);

export default styled(SubscribeButton)``;